import chatService from '../../services/chatService'

class ChatController {
  fetchChatToken = chatService.fetchChatToken
  deleteChatChannel = chatService.deleteChatChannel
}

export default new ChatController()
 


// WEBPACK FOOTER //
// ../src/controllers/chatController/chatController.js